'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Books = require('./Books');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Books).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Books/index.js
// module id = 1120
// module chunks = 1